module.exports = __webpack_public_path__ + "assets/img/5866562921f36360b9fd3acb80bf367c.png";